document.addEventListener('DOMContentLoaded', function () {
  const gbBuilderAccordions = document.querySelectorAll('.gb-builder-accordion');

  if (gbBuilderAccordions.length === 0) return;

  function setupGbBuilderAccordion(gbBuilderAccordion) {
    const items = gbBuilderAccordion.querySelectorAll('.gb-builder-accordion__item');

    items.forEach((item) => {
      const toggle = item.querySelector('.gb-builder-accordion__toggle');
      const content = item.querySelector('.gb-builder-accordion__content');

      if (!toggle || !content) return;

      toggle.addEventListener('click', function () {
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';

        toggle.setAttribute('aria-expanded', String(!isOpen));
        content.setAttribute('aria-hidden', String(isOpen));
        item.classList.toggle('gb-builder-accordion__item--open', !isOpen);
      });
    });
  }

  gbBuilderAccordions.forEach(setupGbBuilderAccordion);
});
